import React, { useState, useEffect } from 'react';
import 'ace-builds';
import Ace from 'react-ace';
import 'ace-builds/src-noconflict/mode-css';
import 'ace-builds/src-noconflict/theme-monokai';
import 'brace/mode/css';
import 'brace/theme/monokai';
import { useMutation, useQuery } from '@apollo/client';
import {
  SET_CLIENT_STATE, GENERAL_SETTINGS, UPDATE_GENERAL_SETTINGS,
} from '../../../graphqls';

export default function CodeEditor() {
  const {
    loading: loadingGeneralSettings,
    data: { generalSettings } = {},
  } = useQuery(GENERAL_SETTINGS);
  const [setState] = useMutation(SET_CLIENT_STATE);
  const [updateGeneralSettings] = useMutation(UPDATE_GENERAL_SETTINGS, {
    refetchQueries: [{ query: GENERAL_SETTINGS }],
  });
  const [value, setValue] = useState('');
  useEffect(() => {
    if (generalSettings.cssOverwrite) {
      setValue(generalSettings.cssOverwrite);
    }
  }, [generalSettings]);

  if (loadingGeneralSettings) {
    return '';
  }

  const onChange = (newValue) => setValue(newValue);
  const onSubmit = () => {
    updateGeneralSettings({ variables: { cssOverwrite: value } });
    setState({ variables: { modalTypeShown: '' } });
  };

  return (
    <div className="css-editor">
      <Ace
        mode="css"
        theme="monokai"
        name="cssEditor"
        value={value}
        onChange={onChange}
        fontSize={12}
        showPrintMargin
        showGutter
        height="350px"
        highlightActiveLine
        setOptions={{
          tabSize: 2,
          useWorker: false,
        }}
      />
      <div className="button-container">
        <button
          type="button"
          className="btn mint-btn"
          onClick={onSubmit}
        >
          Submit
        </button>
      </div>
    </div>
  );
}
